import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Authentication } from '../../services/authentication.service';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { NotificationService } from '../../services/notification.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { TitleService } from '../../services/title.service';
import { UserService } from '../../services/user.service';
import { AccountService } from '../../services/account.service';
import { HistoryService } from '../../services/history.service';
@Component({
  standalone: false,
  selector: 'app-header-new',
  templateUrl: './header-new.component.html',
  styleUrls: ['./header-new.component.css'],
})
export class HeaderNewComponent implements OnInit, OnDestroy {
  notifications: any;
  unreadNotificationsCount = 0;
  userData: any;
  feedbackForm = { type: null, rating: 0, subject: null, followup: false, description: null };
  feedbackTypes = [
    { label: 'General Feedback', value: 'General Feedback' },
    { label: 'Issue or Bug', value: 'Issue or Bug' },
    { label: 'Needed Content', value: 'Needed Content' },
    { label: 'Desired Feature', value: 'Desired Feature' },
  ];
  noInput = true;
  selectedFeedbackType = {};
  routeSubscription: Subscription;

  @ViewChild('feedbackModal') feedbackModal: any;
  subjectFC = new FormControl('');

  constructor(
    private notificationService: NotificationService,
    private historyService: HistoryService,
    readonly authService: Authentication,
    private accountService: AccountService,
    private errorHandlingService: ErrorHandlingService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private readonly modalService: NgbModal,
    private titleService: TitleService,
    readonly userService: UserService,
  ) {
    this.routeSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setTabTitle();
    });
  }

  ngOnInit() {
    this.setTabTitle();
    this.userData = this.userService.getUserDetails();
    this.userData = this.userService.userData;
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  addClassToBodyForResponsiveMenu(): any {
    const body = document.querySelector('body');
    body.classList.toggle('menu-toggle');
  }

  setTabTitle() {
    this.titleService.setTitle(this.activatedRoute.snapshot, this.router.routerState.snapshot);
  }

  getNotifications() {
    if (this.accountService.isAuthenticated()) {
      this.notificationService.getNotifications('type:APP').subscribe(
        (data) => {
          this.notifications = data?.items;
          this.unreadNotificationsCount = data?.items?.filter((notification) => !notification?.viewed).length;
        },
        (err) => {
          this.errorHandlingService.handleError(err, err.url);
        },
      );
    }
  }

  markAllNotificationsAsRead() {
    this.notificationService.readAllNotifications().subscribe(
      (data: any) => {
        this.getNotifications();
      },
      (err) => {
        this.errorHandlingService.handleError(err, err.url);
      },
    );
  }

  readNotification(id: any) {
    this.notificationService.readNotifications(id).subscribe(
      (data) => {
        this.getNotifications();
      },
      (err) => {
        this.errorHandlingService.handleError(err, err.url);
      },
    );
  }

  openFeedbackModal() {
    this.modalService.open(this.feedbackModal, { ariaLabelledBy: 'modal-title', modalDialogClass: 'feedback-modal-width' }).result.then(
      (result) => {
        if (result == 'Send') {
          this.notificationService
            .sendFeedback(
              this.feedbackForm.type,
              this.feedbackForm.rating,
              this.feedbackForm.subject,
              this.feedbackForm.followup,
              this.feedbackForm.description,
            )
            .subscribe((data) => {
              this.resetFeedbackForm();
            });
          this.notificationService.showSuccess('Feedback sent successfully');
          this.resetFeedbackForm();
        } else {
          this.resetFeedbackForm();
        }
      },
      (reason) => {
        //console.log(reason);
      },
    );
  }

  selectFeedbackType(feedback: object) {
    this.selectedFeedbackType = feedback;
    this.feedbackForm.type = feedback['value'];
    this.checkFeedbackInput();
  }

  checkFeedbackType() {
    let type = false;
    if (this.feedbackForm.type != null && this.feedbackForm.type != '') {
      type = true;
    }
    return type;
  }

  setFeedbackSubject() {
    this.feedbackForm.subject = this.subjectFC.value;
    this.checkFeedbackInput();
  }

  checkFeedbackInput() {
    let empty = true;
    for (const key of Object.keys(this.feedbackForm)) {
      const detail = this.feedbackForm[key];
      if (detail != null && detail != '' && key != 'rating') {
        empty = false;
      } else {
        if (detail > 0) {
          empty = false;
        }
      }
    }
    this.noInput = empty;
  }

  resetFeedbackForm() {
    this.feedbackForm = { type: null, rating: 0, subject: null, followup: false, description: null };
    this.subjectFC.reset();
  }

  logout() {
    this.authService.logout();
    this.userService.flush();
  }
}
